import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'

type Microrganismos = {
  cod_microrganismo: number
  concentracao: string
  porcentagem: number
  tipo_porcentagem: number
}

interface PropsPostInoculantes {
  nome: string
  descricao: string
  cod_fabricante: number
  cod_categoria_produto: number
  origem: number
  formulacao: number
  aplicacao: number[]
  tecnologia: number
  volume_dose: number
  doses_por_hectare: number
  finalidades: number[]
  microrganismos: Microrganismos[]
  microrganismos_remover?: number[]
  finalidades_remover?: number[]
  aplicacao_remover?: number[]
  refetch: () => void
}

export const usePostInoculantes = (): {
  carregando_salvar_inoculantes: boolean
  mutate_inoculantes: (params: PropsPostInoculantes) => void
  isSuccess_inoculantes: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostInoculantes> = useMutation(
    async (params: PropsPostInoculantes) => {
      const {
        nome,
        descricao,
        cod_fabricante,
        cod_categoria_produto,
        origem,
        formulacao,
        aplicacao,
        tecnologia,
        volume_dose,
        doses_por_hectare,
        finalidades,
        microrganismos,
        microrganismos_remover,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`recomendacao/bioinsumo?codConta=${localConfig()?.conta}`, {
          nome: nome,
          descricao: descricao,
          cod_fabricante: cod_fabricante,
          cod_categoria_produto: cod_categoria_produto,
          origem: origem,
          formulacao: formulacao,
          aplicacao: aplicacao,
          tecnologia: tecnologia,
          volume_dose: volume_dose,
          doses_por_hectare: doses_por_hectare,
          finalidades: finalidades,
          microrganismos: microrganismos,
          microrganismos_remover: microrganismos_remover
        })
        .then((response: any) => {
          successAlert('Inoculante cadastrado com sucesso!', 5000, 'loading')
          refetch()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar inoculante!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar inoculante!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_inoculantes: mutation.isLoading,
    mutate_inoculantes: mutation.mutate,
    isSuccess_inoculantes: mutation.isSuccess,
  }
}

export const usePutInoculantes = (
  cod: number
): {
  carregando_edit_inoculantes: boolean
  mutate_edit_inoculantes: (params: PropsPostInoculantes) => void
  isSuccess_edit_inoculantes: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostInoculantes> = useMutation(
    async (params: PropsPostInoculantes) => {
      const {
        nome,
        descricao,
        cod_fabricante,
        cod_categoria_produto,
        origem,
        formulacao,
        aplicacao,
        aplicacao_remover,
        tecnologia,
        volume_dose,
        doses_por_hectare,
        finalidades,
        finalidades_remover,
        microrganismos,
        microrganismos_remover,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`recomendacao/bioinsumo/${cod}?codConta=${localConfig()?.conta}`, {
          nome: nome,
          descricao: descricao,
          cod_fabricante: cod_fabricante,
          cod_categoria_produto: cod_categoria_produto,
          origem: origem,
          formulacao: formulacao,
          aplicacao: aplicacao,
          tecnologia: tecnologia,
          volume_dose: volume_dose,
          doses_por_hectare: doses_por_hectare,
          finalidades: finalidades,
          finalidades_remover,
          aplicacao_remover,
          microrganismos: microrganismos,
          microrganismos_remover: microrganismos_remover
        })
        .then((response: any) => {
          successAlert('Inoculantes atualizado com sucesso!', 5000, 'loading')
          refetch()
          return response
        })
        .catch((error: any) => {
          console.log('error', error)
          errorAlert(
            error?.response?.data?.error?.[0]?.msg[0] ?? 'Falha ao editar o inoculante!',
            5000,
            'loading'
          )
          throw error
        })
    }
  )

  return {
    carregando_edit_inoculantes: mutation.isLoading,
    mutate_edit_inoculantes: mutation.mutate,
    isSuccess_edit_inoculantes: mutation.isSuccess,
  }
}
